import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractOptionComponent} from '../abstract-option/abstract-option.component';
import {CodeEditor} from '@acrodata/code-editor';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {html} from '@codemirror/lang-html';
import {oneDark} from '@codemirror/theme-one-dark';

@Component({
  selector: 'app-html-option',
  imports: [
    CodeEditor,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './html-option.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './html-option.component.scss'
})
export class HtmlOptionComponent extends AbstractOptionComponent {
  extensions = [html(), oneDark];
  html = '';

  constructor() {
    super();

    this.fullWidth = true;
  }

  setData(data: any): void {
  }

  getValue(): any {
    return this.html;
  }

  setValue(value: any): void {
    this.html = value.toString();
  }
}
